/**
 * Returns the first element that is a descendant of the root element
 * that matches the specified selector, or group of selectors.
 *
 * @param {string} s The selector to query the DOM with.
 * @return {HTMLElement|null} The first matching element or null if no element found.
 */
const select = (s) => {
  if (!s) {
    return console.warn("[select]: No selector provided.");
  }
  return document.querySelector(s);
};

/**
 * Returns a NodeList of elements that are descendants of the root element
 * and match the specified selector, or group of selectors.
 *
 * @param {string} s The selector to query the DOM with.
 * @return {NodeList} A NodeList of matching elements.
 */
const selectAll = (s) => {
  if (!s) {
    return console.warn("[selectAll]: No selector provided.");
  }
  return document.querySelectorAll(s);
};

/**
 * Creates a new HTML element with the specified tag name.
 *
 * @param {string} element The tag name of the HTML element to create.
 * @param {Object} options An object containing the options for the new element.
 * @return {HTMLElement} The newly created HTML element.
 */
const create = (element, options) => {
  if (!element) {
    return console.warn("[create]: No element provided.");
  }
  return document.createElement(element, options);
};

/**
 * Capitalizes the first character of a string.
 *
 * @param {string} str The string to capitalize.
 * @return {string} The string with the first character capitalized.
 */
function capitalizeFirst(str) {
  if (typeof str !== "string" || str.length === 0) {
    return "";
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export {
  select,
  selectAll,
  create,
  capitalizeFirst,
};
